<h3 mat-dialog-title>{{this.data.tableDef.title ? this.data.tableDef.title:"Table"}} {{data.data['id']!=undefined ? 'Edit':'Add'}}</h3>
<mat-dialog-content [ngSwitch]="this.data.tableDef.title">
    <div *ngSwitchCase="'FAQs'">
      <table style="width: 100%">
        <tr>
          <td style="text-align: right;"><label matLab>Id:</label></td>
          <td ><input matInput readonly type="text" class="aip-input readonly" [(ngModel)]="this.data.data['id']"/></td>
          <td style="text-align: right;"><label matLab>Category:</label><span style="color:red">*</span></td>
          <td>
            <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                [items]="this.dropDownItems['classid']" 
                [(ngModel)]="this.data.data['classid']"    
                bindValue="value"                
                bindLabel="label"
                [id]="'Category'"
                (ngModelChange)="onChange(getItem('classid'))"
                (change)="changeBorderColor(this.data.data['classid'], 'Category')"
            >
            </ng-select> 
          </td>
        </tr>
        <tr>
          <td style="text-align: right;">
            <label matLab>Question Order:</label>
          </td>
          <td>
            <input matInput type="text" class="aip-input" [(ngModel)]="this.data.data['questionorder']"/>
          </td>
          <td style="text-align: right;">
            <label matLab style="line-height:45px!important">Topic:</label><span style="color:red">*</span>
          </td>
          <td>
             <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                        [items]="this.dropDownItems['groupid']" 
                        [(ngModel)]="this.data.data['groupid']"    
                        bindValue="value"                
                        bindLabel="label"
                        [id]="'Group'"
                        (ngModelChange)="onChange(getItem('groupid'))"
                        (change)="changeBorderColor(this.data.data['groupid'], 'Group')"
                    >
                </ng-select>   
          </td>
        </tr>
        <tr>
          <td style="text-align: right;">
            <label matLab>Question:</label>
          </td>
          <td colspan="3">
            <textarea style="width: 100%;" class="aip-input" [(ngModel)]="this.data.data['question']" ></textarea>
          </td>
        </tr>
        <tr>
          <td style="text-align: right;">
            <label matLab>Answer:</label>
          </td>
          <td colspan="3" style="height: 200px; vertical-align: text-top;">
            <div style="display: flex;width: 100%;">
            <div style="width: 100%;min-width: 537px;">
              <div *ngIf="isRichText" id="editorTest" style="height:150px;max-height:70%;"></div>
              <textarea *ngIf="!isRichText" class="aip-input" [(ngModel)]="this.data.data['answer']" style="height: 180px;width: 97%;"></textarea>
            </div>
            <div>
              <span [title]="isRichText ? 'Change to multiline text':'Change to rich text'">
                <svg style="cursor: pointer;" (click)="changeTextInput()" t="1627618320566" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1961" width="20" height="20"><path d="M564.201244 297.1648l125.838223 101.944889H154.259911C131.982222 399.132444 113.777778 416.881778 113.777778 438.499556 113.777778 460.162844 131.982222 477.866667 154.237156 477.866667h647.099733c38.047289 0 55.045689-46.057244 25.895822-69.677511l-211.626667-171.645156a41.119289 41.119289 0 0 0-56.661333 5.12 38.684444 38.684444 0 0 0 5.233778 55.5008z m-81.646933 452.334933l-125.838222-101.922133h535.802311c22.254933 0 40.459378-17.703822 40.459378-39.344356 0-21.617778-18.204444-39.344356-40.459378-39.344355H245.418667c-38.047289 0-55.045689 46.034489-25.895823 69.632l211.626667 171.576889a41.301333 41.301333 0 0 0 57.070933-5.12 39.048533 39.048533 0 0 0-5.666133-55.478045z" p-id="1962"></path></svg>
              </span>
            </div>
            </div>
          </td>
        </tr>
        <tr>
          <td style="text-align: right;"><label matLab>Hot Topics:</label></td>
          <td colspan="3">
            <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                  [items]="this.dropDownItems['flag']" 
                  [(ngModel)]="this.data.data['flag']"    
                  bindValue="value"                
                  bindLabel="label"
                  (ngModelChange)="onChange(getItem('flag'))"
              >
              </ng-select> 
          </td>
        </tr>
        <tr>
          <td style="text-align: right;">
            <label matLab>Created by:</label>
          </td>
          <td>
            <input matInput readonly type="text" class="aip-input readonly" [(ngModel)]="this.data.data['createdby']"/>
          </td>
          <td style="text-align: right;">
             <label matLab>Created:</label>
          </td>
          <td>
            <input matInput readonly type="text" class="aip-input readonly" [value]="this.data.data['created'] | date: 'yyyy-MM-dd HH:mm:ss'"/>
          </td>
        </tr>
      </table>
    </div>
    <div *ngSwitchDefault class="aip-woptions-sidebar">
        <div *ngFor="let item of this.data.tableDef.fields">
            <ng-container *ngIf="getType(item)=='string'">
                <div *ngIf='!item["isRequired"]'>
                    <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                    <input matInput type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]"/>
                </div>
                <div  *ngIf='item["isRequired"] && item["isRequired"]===true'>
                    <label matLab>{{item["label"]?item["label"]:item["name"]}}</label> <span style="color:red">*</span>
                    <input *ngIf="item['label'] !== 'Client Id'" matInput [id]="item['label']?item['label']:item['name']" type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]" (keyup)="changeBorderColor(this.data.data[item['name']],item['label']?item['label']:item['name'])"/>
                    <input *ngIf="item['label'] === 'Client Id'" matInput digitOnly [id]="item['label']?item['label']:item['name']" type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]" (keyup)="changeBorderColor(this.data.data[item['name']],item['label']?item['label']:item['name'])"/>
                </div>   
            </ng-container>
            <ng-container *ngIf="getType(item)=='readonly'&&item['name']!=='isdeleted'">
                <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                <input *ngIf="item.type!='datetime'" matInput readonly type="text" class="aip-input readonly" [(ngModel)]="this.data.data[item['name']]"/>
                <input *ngIf="item.type=='datetime'" matInput readonly type="text" class="aip-input readonly" [value]="this.formatDate(this.data.data[item['name']])"/>
            </ng-container>
            <!-- <ng-container *ngIf="getType(item)=='isRequired'">
                <label matLab>{{item["label"]?item["label"]:item["name"]}}</label> <span style="color:red">*</span>
                <input matInput [id]="item['label']?item['label']:item['name']" type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]" (keyup)="changeBorderColor(this.data.data[item['name']],item['label']?item['label']:item['name'])"/>
            </ng-container> -->

            <ng-container *ngIf="getType(item)=='dropdown'&&!(item['name']=='parentid'&&this.data.data['hideParent']&&this.data.data['hideParent']===true)">
                <diV *ngIf='!item["isRequired"]'>
                    <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                    
                    <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                        [items]="this.dropDownItems[item['name']]" 
                        [(ngModel)]="this.data.data[item['name']]"    
                        bindValue="value"                
                        bindLabel="label"
                        (ngModelChange)="onChange(item)"
                    >
                    </ng-select>    
                </diV>
                <div  *ngIf='item["isRequired"] && item["isRequired"]===true'>
                    <label matLab>{{item["label"]?item["label"]:item["name"]}}</label> <span style="color:red">*</span>
                    <ng-select class="aip-select" appendTo="#selectOverlayDiv" 
                        [items]="this.dropDownItems[item['name']]" 
                        [(ngModel)]="this.data.data[item['name']]"    
                        bindValue="value"                
                        bindLabel="label"
                        [id]="item['label']?item['label']:item['name']"
                        (ngModelChange)="onChange(item)"
                        (change)="changeBorderColor(this.data.data[item['name']],item['label']?item['label']:item['name'])"
                    >
                    </ng-select>   
                </div>
            </ng-container>
        </div>   
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!isReadOnly">
    <button mat-raised-button color="primary" class="aip-button" (click)="save()" cdkFocusInitial>OK</button>    
    <button *ngIf="data.data['id']!=undefined&&this.data.tableDef.tableName=='accounts'&&this.data.data['isdeleted']==false" mat-raised-button color="warn" class="aip-button" (click)="softDelete()">Soft Delete</button>
    <button *ngIf="data.data['id']!=undefined&&this.data.tableDef.tableName!='accounts'" mat-raised-button color="warn" class="aip-button" (click)="delete()">Delete</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>
<mat-dialog-actions align="end" *ngIf="isReadOnly">
    <button mat-raised-button color="primary" class="aip-button" (click)="close()" [mat-dialog-close]="data" cdkFocusInitial>OK</button>  
    <button *ngIf="data.data['id']!=undefined&&this.data.tableDef.tableName=='accounts'" mat-raised-button color="primary" class="aip-button" (click)="active()">Active</button>
    <button *ngIf="data.data['id']!=undefined&&this.data.tableDef.tableName=='accounts'" mat-raised-button color="warn" class="aip-button" (click)="delete()">Hard Delete</button>  
</mat-dialog-actions>

<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>